import React, { useEffect, useRef, useState } from "react";
import SideNavLayout from "../../Sidenav/SideNavLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";
import lateOffenders, { attendanceData } from "../utils/attendancedashboard";
import TopLateOffenders from "./lateoffenders";
import Linegraph from "./linegraph";
import IpadDevices from "./ipaddevices";
import CompanyAttendence from "./companyattendence";
import ClockingTimes from "./clockingtimes";
import dayjs from 'dayjs';
import CountUp from 'react-countup';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import api from "../../api/api";
import { useSelector } from "react-redux";
import { Skeleton } from "@mui/material";
const AttendanceDashboard = () => {
const [dateRange, setDateRange] = useState([
  {
  startDate: new Date(new Date().setDate(new Date().getDate() - 7)), // 7 days ago
    endDate: new Date(), // Today
    key: 'selection'
  }
]);

  const [ontimerate,setOntimeRate]=useState({})
  const [ontimerateloader,setOntimeRateLoader]=useState(false)
  const [totalattendance,setTotalAttaendance]=useState({})
  const [totalattendaceloader,setTotalAttendanceLoader]=useState(false)
  const [missedclockouts,setMissedClockouts]=useState({})
  const[missedclockoutloader,setMissedClockoutLoader]=useState(false)
  const[ipaddevicesuse,setIpadDevicesUse]=useState({})
  const [ipaddevicesuseloader,setIpadDevicesuseLoader]=useState(false)
const[clockingtimes,setClockingTime]=useState({})
   const [showDatePicker, setShowDatePicker] = useState(false);
  const datePickerRef = useRef(null); // Ref to detect clicks outside
  const [attendancetrend,setAttendancetrend]=useState({})
  const [trendtype,setTrendType]=useState('on_time')
  const [companysummary,setCompanySummary]=useState([])
  const[topoffenders,setTopOffenders]=useState([])
  const [ipaddeviceusage,setipaddeviceusage]=useState({})
    const handleSelect = (ranges) => {
    setDateRange([ranges.selection]);
  };
    useEffect(() => {
    const handleClickOutside = (event) => {
      if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
        setShowDatePicker(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [datePickerRef]);
const onTimeRatefetch = async () => {
  try {
    setOntimeRateLoader(true);
    const { startDate, endDate } = dateRange[0];
    const response = await api.get('/v1/dashboard/attendance/on-time-rate', {
      params: {
  
start_date: dayjs(startDate).format('YYYY-MM-DD'),
end_date: dayjs(endDate).format('YYYY-MM-DD'),
    
      }
    });
    if(response.status==200){
      setOntimeRate(response?.data||{})
    }else{
      setOntimeRate({})
    }

  } catch (error) {
    console.log(error);
  } finally {
    setOntimeRateLoader(false);
  }
};
const totalattendacefetch = async () => {
  try {
  setTotalAttendanceLoader(true);
    const { startDate, endDate } = dateRange[0];
    const response = await api.get('/v1/dashboard/attendance/total', {
      params: {
      
start_date: dayjs(startDate).format('YYYY-MM-DD'),
end_date: dayjs(endDate).format('YYYY-MM-DD'),  
      }
    });
    if(response.status==200){
      setTotalAttaendance(response?.data||{})
    }else{
      setTotalAttaendance({})
    }

  } catch (error) {
    console.log(error);
  } finally {
   setTotalAttendanceLoader(false);
  }
};
const missedClockoutfetch = async () => {
  try {
 setMissedClockoutLoader(true);
    const { startDate, endDate } = dateRange[0];
    const response = await api.get('/v1/dashboard/attendance/missed-clockouts', {
      params: {
       
start_date: dayjs(startDate).format('YYYY-MM-DD'),
end_date: dayjs(endDate).format('YYYY-MM-DD'), 
      }
    });
    if(response.status==200){
     setMissedClockouts(response?.data||{})
    }else{
     setMissedClockouts({})
    }

  } catch (error) {
    console.log(error);
  } finally {
  setMissedClockoutLoader(false);
  }
};
const ipaddevicesusefetch = async () => {
  try {
setIpadDevicesuseLoader(true);
 
    const response = await api.get('/v1/dashboard/devices/usage-summary');
    if(response.status==200){
     setIpadDevicesUse(response?.data||{})
    }else{
  setIpadDevicesUse({})
    }

  } catch (error) {
    console.log(error);
  } finally {
setIpadDevicesuseLoader(false);
  }
};
const fetchattendancetrendfetch =async()=>{
  try {
        const { startDate, endDate } = dateRange[0];
    const response=await  api.get('/v1/dashboard/attendance/trends',{
        params: {
       
start_date: dayjs(startDate).format('YYYY-MM-DD'),
end_date: dayjs(endDate).format('YYYY-MM-DD'),
     filter_type:trendtype
      }
    })
    
    if(response.status==200){
      setAttendancetrend(response.data||{})
 
    }else{
      setAttendancetrend({})
    }
    
  } catch (error) {
    console.log(error)
  }finally{

  }
}
const companysummaryfetch = async () => {
  try {

    const { startDate, endDate } = dateRange[0];
    const response = await api.get('/v1/dashboard/attendance/company-wise', {
      params: {
       
start_date: dayjs(startDate).format('YYYY-MM-DD'),
end_date: dayjs(endDate).format('YYYY-MM-DD'),
    
      }
    });
    if(response.status==200){
      setCompanySummary(response?.data||[])
    }else{
     setCompanySummary([])
    }

  } catch (error) {
    console.log(error);
  } 
};
const clockingTimesfetch = async () => {
  try {


    const { startDate, endDate } = dateRange[0];
    const response = await api.get('/v1/dashboard/attendance/clocking-times', {
      params: {
       
start_date: dayjs(startDate).format('YYYY-MM-DD'),
end_date: dayjs(endDate).format('YYYY-MM-DD'),
    
      }
    });
    if(response.status==200){
      setClockingTime(response?.data||{})
    }else{
    setClockingTime({})
    }

  } catch (error) {
    console.log(error);
  } 
};
const topoffendersfetch = async () => {
  try {


    const { startDate, endDate } = dateRange[0];
    const response = await api.get('/v1/dashboard/attendance/top-late-offenders', {
      params: {
      
start_date: dayjs(startDate).format('YYYY-MM-DD'),
end_date: dayjs(endDate).format('YYYY-MM-DD'),
    
      }
    });
    if(response.status==200){
      setTopOffenders(response?.data||[])
    }else{
    setTopOffenders([])
    }

  } catch (error) {
    console.log(error);
  } 
};
const ipaddevicesusagefetch = async () => {
      const { startDate, endDate } = dateRange[0];
  try {
const response = await api.get('/v1/dashboard/ipads-usage', {
    params: {
      
start_date: dayjs(startDate).format('YYYY-MM-DD'),
end_date: dayjs(endDate).format('YYYY-MM-DD'),
    
      }
})
    if(response.status==200){
    setipaddeviceusage(response?.data||{})
    }else{
  setipaddeviceusage({})
    }

  } catch (error) {
    console.log(error);
  } 
};
  const isFirstRender = useRef(true);
  useEffect(() => {

if(showDatePicker)return
    onTimeRatefetch();
   totalattendacefetch();
   missedClockoutfetch()
   ipaddevicesusefetch()
   companysummaryfetch()
   clockingTimesfetch()
  topoffendersfetch()
  ipaddevicesusagefetch()
  }, [showDatePicker]);
useEffect(()=>{
  
fetchattendancetrendfetch()
},[trendtype,showDatePicker,])
const getValidPercentageNumber = (value) => {
  const match = /^(\d+(?:\.\d+)?)%$/.exec(value);
  return match ? parseFloat(match[1]) : null;
};

  const handleClear = () => {
    setDateRange([
      {
        startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
        endDate: new Date(),
        key: 'selection',
      },
    ]);
    setShowDatePicker(false)
  };
  return (
    <div className="h-full ">
      <SideNavLayout>
        <div className="p-2  max-h-[90vh] overflow-y-auto"
        style={{scrollbarWidth:"none"}}>
          {/* Header Section */}
<div className="text-left mb-6 flex justify-between items-center relative">
  <div>
    <h1 className="text-xl font-semibold">Attendance Dashboard</h1>
    {/* <div className="flex items-center gap-1 mt-1 text-sm text-[#717182]">
      <FontAwesomeIcon icon={faCalendar} />
    <div>
  {dateRange[0].startDate?.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })}
</div>

    </div> */}
  </div>

  {/* Date Selector Wrapper */}
  <div className="relative">
    <div
      className="flex gap-2 items-center"
      style={{
        borderRadius: '6px',
        border: '1px solid #E2E8F0',
        background: '#FFF',
        padding: '8px 16px',
        cursor: 'pointer',
      }}
      onClick={() => setShowDatePicker(!showDatePicker)}
    >
      <FontAwesomeIcon icon={faCalendar} />
      <span>
        {dateRange[0].startDate ? dateRange[0].startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''}
        {dateRange[0].endDate && dateRange[0].startDate &&
          ` - ${dateRange[0].endDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`}
      </span>
    </div>

    {/* Date Picker Dropdown */}
    {showDatePicker && (
      <div
        ref={datePickerRef}
        style={{
          position: 'absolute',
          top: '100%',
          right: 0,
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          padding: '16px',
          marginTop: '8px',
          zIndex: 1001,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <DateRangePicker
          ranges={dateRange}
          onChange={handleSelect}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={1}
          direction="horizontal"
          maxDate={new Date()}
        />
        <div className=" flex justify-end">
          <div className="flex flex-row gap-4">
<button className="bg-[#900] text-white text-normal px-4 py-1 rounded-md " 
onClick={()=>handleClear()}
>clear</button>
<button className="bg-[#900] text-white text-normal px-4 py-1 rounded-md "
onClick={()=>{
  setShowDatePicker(false)
}}
>Apply</button>
          </div>
          
        </div>
      </div>
    )}
  </div>
</div>


          {/* Cards Container */}
          <div className="flex flex-wrap gap-2">
             <div
              
                className="relative p-4"
                style={{
                  borderRadius: "12.75px",
                  border: "1px solid rgba(0, 0, 0, 0.10)",
                  background: "#FFF",
                  boxShadow:
                    "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
                  minHeight: "130px",
        
                  flex: "1 1 200px",
                }}
              >
                <div
                  className="absolute top-3 right-3 p-2"
                  style={{
                    borderRadius: "6.75px",
                    background: "rgba(255, 255, 255, 0.80)",
                    boxShadow:
                      "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.13)",
                  }}
                >
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
  <path d="M11.0002 20.6668C16.0628 20.6668 20.1668 16.5628 20.1668 11.5002C20.1668 6.43755 16.0628 2.3335 11.0002 2.3335C5.93755 2.3335 1.8335 6.43755 1.8335 11.5002C1.8335 16.5628 5.93755 20.6668 11.0002 20.6668Z" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11 6V11.5L14.6667 13.3333" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    

                </div>

                <div className="text-[#717182] text-sm text-left">On-Time Rate</div>
           {
  ontimerateloader ? (
    <>
      <Skeleton variant="text" width={80} height={32} />
      <Skeleton variant="text" width={60} height={20} />
    </>
  ) : (
    <>
      <div className="text-[#0A0A0A] text-2xl font-bold mt-1 text-left">
       {(() => {
    const num = getValidPercentageNumber(ontimerate?.on_time_rate);
    return num !== null ? (
      <CountUp end={num} suffix="%" duration={1} />
    ) : (
      ontimerate?.on_time_rate || "--"
    );
  })()}
      </div>
      <div
        className={`flex items-center text-xs mt-1 ${
          ontimerate?.change?.includes('+') ? 'text-[#009966]' : 'text-[#cc0000]'
        }`}
      >
        <FontAwesomeIcon
          icon={ontimerate?.change?.includes('+') ? faArrowUp : faArrowDown}
          className="mr-1"
        />
        {ontimerate?.change || '-- %'}
      </div>
    </>
  )
}
                <div className="text-[#717182] text-sm mt-1 text-left">
                Employees arriving on time
                </div>
              </div>
                <div
              
                className="relative p-4"
                style={{
                  borderRadius: "12.75px",
                  border: "1px solid rgba(0, 0, 0, 0.10)",
                  background: "#FFF",
                  boxShadow:
                    "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
                  minHeight: "130px",
        
                  flex: "1 1 200px",
                }}
              >
                <div
                  className="absolute top-3 right-3 p-2"
                  style={{
                    borderRadius: "6.75px",
                    background: "rgba(255, 255, 255, 0.80)",
                    boxShadow:
                      "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.13)",
                  }}
                >
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
  <path d="M14.6668 19.75V17.9167C14.6668 16.9442 14.2805 16.0116 13.5929 15.3239C12.9053 14.6363 11.9726 14.25 11.0002 14.25H5.50016C4.5277 14.25 3.59507 14.6363 2.90744 15.3239C2.2198 16.0116 1.8335 16.9442 1.8335 17.9167V19.75" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.6665 3.36719C15.4528 3.57103 16.1491 4.03018 16.6462 4.67258C17.1433 5.31498 17.413 6.10425 17.413 6.91652C17.413 7.72879 17.1433 8.51807 16.6462 9.16046C16.1491 9.80286 15.4528 10.262 14.6665 10.4659" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M20.1665 19.75V17.9166C20.1659 17.1042 19.8955 16.315 19.3978 15.6729C18.9 15.0308 18.2031 14.5722 17.4165 14.3691" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.25016 10.5833C10.2752 10.5833 11.9168 8.94171 11.9168 6.91667C11.9168 4.89162 10.2752 3.25 8.25016 3.25C6.22512 3.25 4.5835 4.89162 4.5835 6.91667C4.5835 8.94171 6.22512 10.5833 8.25016 10.5833Z" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    

                </div>

                <div className="text-[#717182] text-sm text-left">Total Attendance</div>
           {
 totalattendaceloader ? (
    <>
      <Skeleton variant="text" width={80} height={32} />
      <Skeleton variant="text" width={60} height={20} />
    </>
  ) : (
    <>
      <div className="text-[#0A0A0A] text-2xl font-bold mt-1 text-left">
    {typeof totalattendance?.total_attendance === 'number' && !isNaN(totalattendance.total_attendance) ? (
    <CountUp end={totalattendance.total_attendance} duration={1} />
  ) : (
    totalattendance?.total_attendance ?? '--'
  )}

      </div>
      <div
        className={`flex items-center text-xs mt-1 ${
          totalattendance?.change?.includes('+') ? 'text-[#009966]' : 'text-[#cc0000]'
        }`}
      >
        <FontAwesomeIcon
          icon={ontimerate?.change?.includes('+') ? faArrowUp : faArrowDown}
          className="mr-1"
        />
        {totalattendance?.change || '-- '}
      </div>
    </>
  )
}
                <div className="text-[#717182] text-sm mt-1 text-left">
         Total employees in attendance
                </div>
              </div>
                 <div
              
                className="relative p-4"
                style={{
                  borderRadius: "12.75px",
                  border: "1px solid rgba(0, 0, 0, 0.10)",
                  background: "#FFF",
                  boxShadow:
                    "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
                  minHeight: "130px",
        
                  flex: "1 1 200px",
                }}
              >
                <div
                  className="absolute top-3 right-3 p-2"
                  style={{
                    borderRadius: "6.75px",
                    background: "rgba(255, 255, 255, 0.80)",
                    boxShadow:
                      "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.13)",
                  }}
                >
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
  <path d="M19.2499 11.5C19.7559 11.5 20.1712 11.0885 20.1208 10.5852C19.9094 8.4807 18.9768 6.51403 17.4811 5.01859C15.9853 3.52316 14.0184 2.591 11.9139 2.38013C11.4097 2.32972 10.999 2.74497 10.999 3.25097V10.5843C10.999 10.8274 11.0956 11.0606 11.2675 11.2325C11.4394 11.4044 11.6726 11.501 11.9157 11.501L19.2499 11.5Z" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M19.4425 15.0659C18.8594 16.445 17.9473 17.6603 16.7859 18.6054C15.6246 19.5506 14.2494 20.1969 12.7806 20.4878C11.3118 20.7787 9.7941 20.7054 8.36018 20.2742C6.92626 19.8431 5.61978 19.0672 4.55498 18.0145C3.49017 16.9618 2.69946 15.6643 2.25196 14.2354C1.80446 12.8065 1.71381 11.2897 1.98793 9.81765C2.26204 8.34562 2.89258 6.96315 3.82442 5.7911C4.75626 4.61905 5.96102 3.69311 7.33338 3.09424" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    

                </div>

                <div className="text-[#717182] text-sm text-left">Missed Clock outs</div>
           {
missedclockoutloader? (
    <>
      <Skeleton variant="text" width={80} height={32} />
      <Skeleton variant="text" width={60} height={20} />
    </>
  ) : (
    <>
      <div className="text-[#0A0A0A] text-2xl font-bold mt-1 text-left">
  {typeof missedclockouts?.missed_clockout_count === 'number' && !isNaN(missedclockouts.missed_clockout_count) ? (
    <CountUp end={missedclockouts.missed_clockout_count} duration={1} />
  ) : (
    missedclockouts?.missed_clockout_count ?? '--'
  )}

      </div>
      <div
        className={`flex items-center text-xs mt-1 ${
         missedclockouts?.missed_clockout_rate?.includes('+') ? 'text-[#009966]' : 'text-[#cc0000]'
        }`}
      >
        <FontAwesomeIcon
          icon={missedclockouts?.missed_clockout_rate?.includes('+') ? faArrowUp : faArrowDown}
          className="mr-1"
        />
        {missedclockouts?.missed_clockout_rate || '-- '}
      </div>
    </>
  )
}
                <div className="text-[#717182] text-sm mt-1 text-left">
Percentage of missed clock outs
                </div>
              </div>
               <div
              
                className="relative p-4"
                style={{
                  borderRadius: "12.75px",
                  border: "1px solid rgba(0, 0, 0, 0.10)",
                  background: "#FFF",
                  boxShadow:
                    "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
                  minHeight: "130px",
        
                  flex: "1 1 200px",
                }}
              >
                <div
                  className="absolute top-3 right-3 p-2"
                  style={{
                    borderRadius: "6.75px",
                    background: "rgba(255, 255, 255, 0.80)",
                    boxShadow:
                      "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.13)",
                  }}
                >
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
  <path d="M16.4998 2.3335H5.49984C4.48732 2.3335 3.6665 3.15431 3.6665 4.16683V18.8335C3.6665 19.846 4.48732 20.6668 5.49984 20.6668H16.4998C17.5124 20.6668 18.3332 19.846 18.3332 18.8335V4.16683C18.3332 3.15431 17.5124 2.3335 16.4998 2.3335Z" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11 17H11.01" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    

                </div>

                <div className="text-[#717182] text-sm text-left">iPad Devices In Use</div>
           {
ipaddevicesuseloader? (
    <>
      <Skeleton variant="text" width={80} height={32} />
      <Skeleton variant="text" width={60} height={20} />
    </>
  ) : (
    <>
      <div className="text-[#0A0A0A] text-2xl font-bold mt-1 text-left">
    {(() => {
    const value = ipaddevicesuse?.display;
    if (typeof value === 'string' && /^\d+\/\d+$/.test(value)) {
      const [left, right] = value.split('/');
      const leftNum = parseInt(left, 10);
      return (
        <>
          <CountUp end={leftNum} duration={1} />
          {`/${right}`}
        </>
      );
    } else {
      return value ?? '--';
    }
  })()}

      </div>
      <div
        className={`flex items-center text-xs mt-1 ${
     true? 'text-[#009966]' : 'text-[#cc0000]'
        }`}
      >
        <FontAwesomeIcon
          icon={true ? faArrowUp : faArrowDown}
          className="mr-1"
        />
        {ipaddevicesuse?.active_percentage || '-- '}
      </div>
    </>
  )
}
                <div className="text-[#717182] text-sm mt-1 text-left">
Active devices in field
                </div>
              </div>
            {/* {attendanceData.map((item, index) => (
              <div
                key={index}
                className="relative p-4"
                style={{
                  borderRadius: "12.75px",
                  border: "1px solid rgba(0, 0, 0, 0.10)",
                  background: "#FFF",
                  boxShadow:
                    "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
                  minHeight: "130px",
        
                  flex: "1 1 200px",
                }}
              >
                <div
                  className="absolute top-3 right-3 p-2"
                  style={{
                    borderRadius: "6.75px",
                    background: "rgba(255, 255, 255, 0.80)",
                    boxShadow:
                      "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.13)",
                  }}
                >
     
               {typeof item.icon === "string" ? (
  <img src={item.icon} alt="icon" className="w-5 h-5 object-contain" />
) : React.isValidElement(item.icon) ? (
  <span className="w-5 h-5">{item.icon}</span> // for inline SVG or JSX icons
) : (
  <FontAwesomeIcon icon={item.icon} className="w-5 h-5" />
)}

                </div>

                <div className="text-[#717182] text-sm text-left">{item.title}</div>
                <div className="text-[#0A0A0A] text-2xl font-bold mt-1 text-left">
                  {item.value}
                </div>
                <div
                  className={`flex items-center text-xs mt-1 ${
                    item.changePositive ? "text-[#009966]" : "text-[#cc0000]"
                  }`}
                >
                  <FontAwesomeIcon
                    icon={item.changePositive ? faArrowUp : faArrowDown}
                    className="mr-1"
                  />
                  {item.change}%
                </div>
                <div className="text-[#717182] text-sm mt-1 text-left">
                  {item.description}
                </div>
              </div>
            ))} */}
          </div>
    
<div className="flex flex-col sm:flex-row gap-4 mt-8 items-stretch">
  {/* Left Section - 70% */}
  <div className="sm:w-[70%] w-full flex flex-col gap-4 ">
    <Linegraph 
    trendtype={trendtype}
    setTrendType={setTrendType}
    attendancetrend={attendancetrend}
    />
    <IpadDevices 
    ipaddevicesuse={ipaddeviceusage}
    />

    
  </div>

  {/* Right Section - 30% */}
  <div className="sm:w-[30%] w-full bg-[#f0f0f0] rounded-md shadow-sm ">
    <TopLateOffenders  topoffenders={topoffenders}/>
  </div>
</div>

<div className="w-full flex flex-col sm:flex-row gap-4 mt-8">
  {/* Left - CompanyAttendance (50%) */}
  <div className="w-full sm:w-1/2">
    <CompanyAttendence 
    companysummary={companysummary}
    />
  </div>

  {/* Right - Other (50%) */}
  <div className="w-full sm:w-1/2">
 <ClockingTimes 
 ClockingTimes={clockingtimes}
 />
  </div>
</div>
        </div>
      </SideNavLayout>
    </div>
  );
};

export default AttendanceDashboard;
